import React, { useState } from 'react';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import { TRANSLATION_KEY } from '../constants';
import { downloadPublisherBlacklist } from '../service';
import { triggerFileDownload } from '../utils';
import css from '../style.css';

const PublisherBlacklistDownload = () => {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = () => {
        if (downloading) return;
        setDownloading(true);
        downloadPublisherBlacklist()
            .then(({ contents, filename }) => triggerFileDownload(contents, filename))
            .catch(error => console.error('Failed to download publisher blacklist', error))
            .finally(() => setDownloading(false));
    };

    return (
        <span className={css.downloadAction}>
            <Icon
                name="download"
                size={IconSizes.MEDIUM}
                variant={IconVariants.ACTIVE}
                disabled={downloading}
                hoverText={`${TRANSLATION_KEY}.PUBLISHER.DOWNLOAD`}
                onClick={handleDownload}
            />
        </span>
    );
};

export default PublisherBlacklistDownload;
